export interface BiCropLots {

	// ROWS

	// CYCLE id numeric identifier
	cycleId: number
	// CYCLE uuid string identifier
	cycleUuid: string
	// CROP name 
	cropName: string
	// CROP LOT numeric identifier,
	cropLotId: number
	// CROP LOT string identifier
	cropLotUuid: string
	// LOT code
	lotCode: string
	// GROW UNIT name
	growUnitId: string

	// COLS

	// date when the CYCLE is sown. It is the start of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	seedingDate: string
	// date when the CYCLE is harvested. The end of the CYCLE. It is a date string in the format "yyyy-mm-dd"
	harvestingDate: string
	/**
	 * extra_data: ["bi_crop_cycle"]
	 */
	growing_date?: string

	growingDate: string

	// VALUES 

	// theoretical yield forecast in kg. It is a number
	plannedYield: number
	// actual yield in kg. It is a number
	yield: number
	// unknown
	plannedYieldBeforeIncidents: number
	// yield for a single TROLLEY
	yieldPerTrolley: number
	// number of seeds in a single TROLLEY, 
	trolleysToSeed: number
	// unknown
	trolleysToHarvest: number
	// unknown
	unitsYield: number
	// number of INCIDENTS for the current CYCLE
	nOfIncidents: number
	// number of kg lost per INCIDENTS
	lostYield: number

	// EXTRA DATA

	// average yield per tray (already calculated both before and after incidents)
	yieldPerTray: number

	/** 
	average yield of a square meter in 365 days. to calculate it:
	take the yield for 1 square meter
	take the number of days of the last phase (harvest phase)
	divide 365 / days of harvest phase
	multiply that for the m2 yield 
	*/
	yieldPerMqPerYear: number

	/** 
	 * set of layer names (no virtual layers) of the crop lot. in the export, it should be threated as a single text field. is a array of string 
	 * extra_data: ["bi_layers"]
	 * */
	layersName?: string[]

	yieldPerMqOnHarvestedTrolleys: number
	yieldPerMqOnTotalTrolleys: number
	gelUsedG: number
	seedUsedG: number
	plannedYieldPerMqPerYear: number
	plannedYieldPerTray: number
	affectedTrays: number
	nOfTrays: number
	seedPerTray: number
	gelPerTray: number
	cycleLayers: number
}









export interface BiIncidentPerCropLot {

	// ROWS
	growUnitId: number
	cropName: string
	cropId: number
	lotCode: string
	layerId: Number
	// identificativo dell'INCiDENT
	incidentId: number
	incidentCode: string // JFOOD CODE

	// COLS
	dateOfOccurrence: string
	harvestingDate: string

	// VALUES
	// numero di trolley persi
	trolleysLost: Number
	traysLost: number
}

export interface BiAlerts {

	// ROWS
	farmId: number,
	growUnitId: number,
	// ALERT https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-27855
	uuid: string,
	message: string,
	severity: number,

	// COLS
	firstOccurredAt: string,
	lastOccurredAt: string,

	// VALUE
	count: number
}

export enum BI_PRESETS {
	YIELD = "yield",
	INCIDENTS = "incidents",
	ALERTS = "alerts"
}
